import $ from 'jquery';
import _ from 'lodash-es';
import Tour from 'bootstrap-tour';

function quickSearchExplanation(options) {
    if ($('body.results').length && document.___location.search.indexOf('src=sample') >= 0) {
        const quickSearchTour = new Tour(options);
        const tourWhiteList = $.fn.tooltip.Constructor.DEFAULTS.whiteList;
        tourWhiteList.button = ["class", "data-role"];

        // Initialize the tour
        quickSearchTour.init();

        // Start the tour
        quickSearchTour.start();

        // If user clicks on a search result the tour will end
        $('.result').find('a').on('click', () => {
            quickSearchTour.end();
        });
    }
}

function alertFacetsExplanation() {
    // Only render this helper if:
    //  -- there are > 1000 results (defined in template layer),
    //  -- the user isn't looking at a sample search,
    //  -- the user hasn't previously seen the basic search tour.
    if ($('#huge-count', 'body.results').length && document.___location.search.indexOf('src=sample') === -1 && localStorage.getItem('basicSearchTour_end') !== 'yes') {
        const tourTemplate = '<div class="hidden-xs popover popover--tour" role="tooltip"> <div class="arrow"></div> <h3 class="popover-title popover-title--tour"></h3> <div class="popover-content popover-content--tour"></div> <div class="popover-navigation">  <button class="btn btn-primary" data-role="end">GOT IT</button> </div> </div>';

        const alertToFacets = new Tour({
            name: 'alertToFacets',
            template: tourTemplate,
            steps: [
                {
                    element: '#huge-count',
                    title: "Wow! That's a lot.",
                    content: '<i class="fa fa-arrow-left"></i> You can usually limit the number of results by selecting one or more of the filters in the left-hand menu.',
                    placement: 'bottom',
                },
            ],
        });
        // Initialize the tour
        alertToFacets.init();
        // Start the tour
        alertToFacets.start();

        // End the tour and set localStorage Var if the user clicks any link in the sidebar or main
        // body without closing the popover.
        $('a', '#aside-primary, #page-section').on('click', () => {
            alertToFacets.end();
        });
    }
}

// Reset the progress of a tour if user selects to take the tour from tour page
function tourReset() {
    if ($('body.tour').length) {
        $('[data-reset-tour]').on('click', function () {
            const tour = new Tour({
                name: $(this).attr('data-reset-tour'),
            });

            tour.restart();
        });
    }
}

function tourScrollSpy() {
    if ($('body.tour').length) {
        const $animatedItems = $('div.timeline__panel--pointy');
        const $window = $(window);

        // eslint-disable-next-line no-inner-declarations
        function testInView() {
            const windowHeight = $window.height();
            const windowTopPos = $window.scrollTop();
            const windowBottomPos = (windowTopPos + windowHeight);

            $.each($animatedItems, function () {
                const $element = $(this);
                const animation = $element.attr('data-animation');
                const elementHeight = $element.outerHeight();
                const elementTopPos = $element.offset().top;
                const elementBottomPos = (elementTopPos + elementHeight);

            // check to see if this current container is within viewport
            if ((elementBottomPos >= windowTopPos) && (elementTopPos <= windowBottomPos) && !($element.hasClass('complete'))) {
              $element.addClass(`${animation} complete`);
            }
          });
        }

        $window.on('scroll resize', _.throttle(testInView, 100));

        $window.trigger('scroll');
    }
}

// Main tour page.  Highlight active link of parallel active slide
function activeCurrentTourLink() {
    if ($('body.tour').length) {
        $('.carousel').on('slide.bs.carousel', (e) => {
            const $active = $(e.relatedTarget);
            const activeIndex = $active.index();
            const $relatedText = $active.closest('.timeline__row').find('.timeline__body--text');

            $relatedText.find('a')
                        .removeClass('active-text')
                        .end()
                        .find(`a[data-slide-to="${activeIndex}"]`)
                        .addClass('active-text');
        });
    }
}

export {
    quickSearchExplanation,
    alertFacetsExplanation,
    tourReset,
    tourScrollSpy,
    activeCurrentTourLink,
};
